module.exports = __webpack_public_path__ + "static/media/test_2.0cc3acf1.svg";